// extracted by mini-css-extract-plugin
module.exports = {"container":"localElectionResult_container__3yYNT"};